<script>

export default {
	components: {},
	props: ['id', 'firstRows', 'columns'],
	data() {
		return {
			availableFields: [
				'code',
				'original_price',
				'current_price',
				'name',
				'first_name',
				'last_name',
				'email',
				'expires_at'
			],
			selectedFields: [],
			errors: {},
			submitDisabled: true,
			isLoading: false
		}
	},
	beforeMount() {

		for (let j = 0; j < this.columns; j++) {
			this.selectedFields[j] = 'no_import';
		}

		for (let j = 0; j < this.firstRows[0].length; j++) {

			let fieldKey = this.firstRows[0][j];

			if (fieldKey === 'Koodi' || fieldKey === 'code') {
				this.fieldSelected(j, 'code');
			} else if (fieldKey === 'Ostohinta' || fieldKey === 'original_price') {
				this.fieldSelected(j, 'original_price');
			} else if (fieldKey === 'Saldo' || fieldKey === 'current_price') {
				this.fieldSelected(j, 'current_price');
			} else if (fieldKey === 'Asiakas' || fieldKey === 'name') {
				this.fieldSelected(j, 'name');
			} else if (fieldKey === 'Etunimi' || fieldKey === 'first_name') {
				this.fieldSelected(j, 'first_name');
			} else if (fieldKey === 'Sukunimi' || fieldKey === 'last_name') {
				this.fieldSelected(j, 'last_name');
			} else if (fieldKey === 'Email' || fieldKey === 'Sähköposti' || fieldKey === 'email') {
				this.fieldSelected(j, 'email');
			} else if (fieldKey === 'Eräpäivä' || fieldKey === 'expires_at') {
				this.fieldSelected(j, 'expires_at');
			}

		}

	},
	methods: {
		reset()
		{
			$('#confirmationRestartModal').modal('toggle');
		},
		async onConfirm() {

			this.isLoading = true;

			await axios.post('/import-gift-cards/' + this.id + '/map-fields', {fields: this.selectedFields}).then(response => {

				window.location = '/import/' + this.id +  '/handle-invalid-rows';

			}).catch(error => {

				if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

				this.isLoading = false;

			});

		},
		fieldSelected(index, value) {

			for (let i = 0; i < this.selectedFields.length; i++) {

				if (index !== i && this.selectedFields[i] === value && value !== 'no-import') {
					this.selectedFields[i] = null;
				}

			}

			this.selectedFields[index] = value;

			this.submitDisabled = false;

			if (this.selectedFields.includes('code') === false) {
				this.submitDisabled = true;
				return;
			}

			if (this.selectedFields.includes('current_price') === false) {
				this.submitDisabled = true;
				return;
			}

		}
	}
}

</script>